export const WAC_SIGNUP_FORM_KEY_BASE = 'WacSignupForm.';
export const SIGNUP_OFFERING_LABEL_KEY_BASE =
  WAC_SIGNUP_FORM_KEY_BASE + 'signupOffering';
export const TRIAL_DURATION_LABEL_KEY_BASE =
  SIGNUP_OFFERING_LABEL_KEY_BASE + 'TrialLengthText';
export const TRIAL_DURATION_LABEL_KEY_EXISTING_SITE =
  TRIAL_DURATION_LABEL_KEY_BASE + 'ExistingSite';
export const TRIAL_DURATION_LABEL_KEY_NEW_SITE =
  TRIAL_DURATION_LABEL_KEY_BASE + 'NewSite';
export const SIGNUP_OFFERING_LABEL_KEY_PREFIX =
  SIGNUP_OFFERING_LABEL_KEY_BASE + 'IncludesFeatures';
export const SIGNUP_SIDE_INFO_HEADER_PREFIX =
  WAC_SIGNUP_FORM_KEY_BASE + 'sideInfoHeader';

export const [
  CONFLUENCE,
  JIRA_CORE,
  JSW,
  JSD,
  OPSGENIE,
  BITBUCKET,
  STATUSPAGE,
  DEVELOPER_MODE,
  DEVOPS,
  TEAM_CENTRAL,
  JIRA_PRODUCT_DISCOVERY,
  COMPASS,
  FABRIC,
  BEACON,
  JIRA_FAMILY
] = [
  'Confluence',
  'JiraCore',
  'JSW',
  'JSD',
  'Opsgenie',
  'Bitbucket',
  'Statuspage',
  'DeveloperMode',
  'Devops',
  'Townsquare',
  'JiraProductDiscovery',
  'Compass',
  'Canvas',
  'Beacon',
  'Jira'
];

export const PRODUCT_NAMES = [
  JSD,
  OPSGENIE,
  BITBUCKET,
  STATUSPAGE,
  DEVELOPER_MODE,
  DEVOPS,
  CONFLUENCE,
  TEAM_CENTRAL,
  JSW,
  JIRA_PRODUCT_DISCOVERY,
  COMPASS,
  FABRIC,
  BEACON
];
export const STANDARD_EDITION_LABEL_KEY = 'Standard';
export const FREE_EDITION_LABEL_KEY = 'Free';
export const PREMIUM_EDITION_LABEL_KEY = 'Premium';
export const BETA_EDITION_LABEL_KEY = 'Beta';
export const STANDARD_EDITION_HALP_PROMO_KEY = 'Halp'; // SPICE-738 JSM promo for existing HALP users
export const BUNDLE_LABEL_KEY = 'Bundle';
export const MIGRATION_USERS_LABEL_KEY = 'userTypeUsersLabel';
export const MIGRATION_AGENTS_LABEL_KEY = 'userTypeAgentsLabel';
export const EDITION_LABEL_ARRAY = [
  STANDARD_EDITION_LABEL_KEY,
  FREE_EDITION_LABEL_KEY,
  PREMIUM_EDITION_LABEL_KEY,
  STANDARD_EDITION_HALP_PROMO_KEY
];

const SOCIAL_PROOF_KEY_PREFIX =
  'WacSignupForm.signupOfferingIncludesFeaturesSocialProof';

export const SOCIAL_PROOF_TEXT_KEY_PREFIX = SOCIAL_PROOF_KEY_PREFIX + 'Text';
export const SOCIAL_PROOF_SUPPORT_IMAGE_KEY_PREFIX =
  SOCIAL_PROOF_KEY_PREFIX + 'Image';
export const SOCIAL_PROOF_HERO_IMAGE_KEY_PREFIX =
  SOCIAL_PROOF_KEY_PREFIX + 'HeroImage';

export const FIRST_IMPRESSION_JIRA_SOFTWARE_FEATURE_LIST = 'JSWFI';
export const FIRST_IMPRESSION_JIRA_SERVICE_DESK_FEATURE_LIST = 'JSDFI';
